<script setup lang="ts">
import { useWebContext } from "~/composables/webContext";
import { useNuxtApp } from "#imports";

const { $t } = useNuxtApp();
const { isQueens } = useWebContext();
</script>

<template>
  <div class="relative overflow-hidden bg-black">
    <NuxtImg
      :src="isQueens ? '/img/header/header-bg-queens-black.png' : '/img/header/header-bg-kings-black.png'"
      class="absolute inset-0 w-full h-full object-cover object-top pointer-events-none select-none opacity-50 rtl:-scale-x-100"
      :class="isQueens ? 'md:object-[100%_30%]' : 'md:object-[100%_15%]'"
      aria-hidden="true"
      loading="eager"
      fetchpriority="high"
      format="webp"
      quality="100"
      width="1920"
      height="1080"
      sizes="100vw sm:100vw md:100vw lg:100vw xl:1920px"
    />
    <div
      class="absolute bottom-0 inset-x-0 h-16 bg-gradient-to-b from-transparent to-black pointer-events-none"
    />
    <div
      class="relative z-10 kql-w-container px-6 py-8 md:py-14 flex flex-col md:flex-row md:items-center gap-8 md:gap-12"
    >
      <div>
        <h1 class="font-kings text-5xl md:text-7xl uppercase mb-3 tracking-wide leading-none">
          {{ $t("howToPlay.title") }}
        </h1>
        <p class="text-white/80 text-lg md:text-xl">{{ $t("howToPlay.subtitle") }}</p>
      </div>
    </div>
  </div>
</template>
